import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IConnectContact } from '@epicuro-next/data/connect';
import { ConnectionStatus } from '@epicuro-next/models/users';
import { selectActiveAccount } from '@epicuro-next/state/accounts-state';
import {
  selectUserConnectionStatus,
  selectUserContactsState,
  setCurrentUserContactState,
} from '@epicuro-next/state/connect-state';
import { selectIsSalesRep } from '@epicuro-next/state/user-state';
import { select, Store } from '@ngrx/store';
import { Account } from 'graphql-api/gql-api-interfaces';
import { map } from 'rxjs/operators';

export interface GroupedAccount
  extends Pick<Account, 'externalId' | 'accountId' | 'name'> {
  users: IConnectContact[];
  active: boolean;
}

@Component({
  selector: 'epc-user-contacts-wrapper',
  templateUrl: './user-contacts-wrapper.component.html',
  styleUrls: ['./user-contacts-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserContactsWrapperComponent {
  public isSalesRep$ = this.store.pipe(select(selectIsSalesRep));
  public activeAccount$ = this.store.select(selectActiveAccount);
  public contacts$ = this.store.select(selectUserContactsState);

  public userCalling$ = this.store.pipe(
    select(selectUserConnectionStatus),
    map((connectionStatus) => connectionStatus === ConnectionStatus.ONCALL),
  );

  constructor(private store: Store) {}

  public callContact(contact: IConnectContact) {
    this.store.dispatch(setCurrentUserContactState({ contact }));
  }
}
